export default {

  toggleLoading(state, isLoading = false) {
    state.loading = isLoading;
  },

  setAppList(state, appList = []) {
    state.appList = appList;
  },

  selectApp(state, selectedApp = {}) {
    state.selectedApp = selectedApp;
  },

  setAppConfigById(state, appConfig = {}) {
    state.appConfig = appConfig;
  },

  setAboutModalToActive(state, showAboutModal = false) {
    state.showAboutModal = showAboutModal;
  },

  setConfigModalToActive(state, showConfigModal = false) {
    state.showConfigModal = showConfigModal;
  },

  setEditModalToActive(state, showEditModal = false) {
    state.showEditModal = showEditModal;
  },

  setReportProblemModalToActive(state, showReportProblemModal = false) {
    state.showReportProblemModal = showReportProblemModal;
  },

  setAppsWithoutFilter(state, appsWithoutFilter = []) {
    state.appsWithoutFilter = appsWithoutFilter;
  },

  setUpdateAppConfig(state, appConfigUpdated = []) {
    state.appConfigUpdated = appConfigUpdated;
  },

  clearAppNameFilterFieldValue(state, appNameFilterFieldValue = '') {
    state.appNameFilterFieldValue = appNameFilterFieldValue;
  },

  setAppListFilter(state, appListFilter = {}) {
    state.appListFilter = appListFilter;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations/store/mutations.js